<template>
  <div id="VehicleList">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <template v-if="customerId != undefined">
              <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="filterName">
              </custom-pagination>
              <div class="view-page-table">
                  <vue-good-table
                          mode="remote"
                          ref="listPendingReservations"
                          title="Reservations"
                          @on-page-change="onPageChange"
                          @on-sort-change="onSortChange"
                          @on-column-filter="onColumnFilter"
                          @on-per-page-change="onPerPageChange"
                          :totalRows="totalRecords"
                          :columns="columns"
                          :rows="rows"
                          :isLoading=false
                          :paginationOptions="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      setCurrentPage:listCurrentPage,
                                      dropdownAllowAll: false

                                  }"
                          :search-options="{
                                  enabled: false,
                                  }"
                          :sort-options="{
                                  enabled: true,
                                  }"
                          :select-options="{
              selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
            }"
                  >
                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                          <div :key="key">
                              <div v-if="props.column.field == 'reference_no'">
                                  <a href="javascript:void(0)" class="color-blue" v-on:click="selectAction(props.row.id ,props.row.truck_id ,flag='view', props.row.resvId)" title="View Reservation">
                                      {{props.row.reference_no}}
                                  </a>
                              </div>
                              <div v-else>
                                  {{props.formattedRow[props.column.field]}}
                              </div>
                          </div>
                      </template>

                  </vue-good-table>

              </div>
              <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
              </custom-pagination>
      </template>
      <template v-else>
          <template v-if="cantAccess === true">
                <div class="admin-page-content current-reservation-list">
                    <div class="btn-groups text-right">
                      <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                      <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()"  v-if="exportRes && hideButton === false">
                          <i class="fp-export"></i> Export
                      </a>
                      <a href="javascript:void(0)" v-if="addRes && hideButton === false" v-on:click="makeReservationNew" class='btn btn-primary'>
                      <i class="fp-calendar"> </i> Add Reservation
                      </a>
                    </div>
                    <data-table-filter-config :moduleName="filterName" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                    <div class="data-table bg-white overflow-hidden">
                      <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                      <section class="bg-white data-table">
                          <custom-pagination
                              :page-changed="onPageChange"
                              :per-page-changed="onPerPageChange" :moduleName="filterName" :position="'top'">
                          </custom-pagination>

                          <vue-good-table
                                  mode="remote"
                                  ref="reservationListTable"
                                  title="Reservations"
                                  @on-page-change="onPageChange"
                                  @on-sort-change="onSortChange"
                                  @on-column-filter="onColumnFilter"
                                  @on-per-page-change="onPerPageChange"
                                  @on-selected-rows-change="selectionChanged"
                                  :totalRows="totalRecords"
                                  :columns="userColumns"
                                  :rows="rows"
                                  :isLoading=false
                                  :paginationOptions="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      dropdownAllowAll: false,
                                      setCurrentPage:listCurrentPage,
                                      perPageDropdown:dropDownPerPage,
                                  }"
                                  :search-options="{
                                  enabled: false,
                                  }"
                                  :select-options="{
                                    enabled: rental_reservation_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                }"

                          >
                          <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                              <div :key="key">
                                  <div v-if="props.column.field == 'reference_no'">
                                    <a href="javascript:void(0)" class="color-blue" v-on:click="selectAction(props.row.id ,props.row.truck_id ,flag='view', props.row.resvId)" title="View Reservation">
                                      {{props.row.reference_no}}
                                    </a>
                                  </div>
                                  <div v-else>
                                      {{props.formattedRow[props.column.field]}}
                                  </div>
                              </div>
                          </template>
                            <div slot="selected-row-actions">
                              <button v-if="rental_reservation_value" id="deleteReservationBtn" v-on:click.prevent="reservationDelete()" class="btn btn-primary">Delete</button>
                            </div>
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                      </section>
                    </div>
                    <div class="modal fade invoice-modal" id="reservation_modal" ref="resModal" data-backdrop="static" data-keyboard="false" aria-labelledby="resModal" aria-hidden="true">
                          <div class="modal-dialog modal-lg" role="document">
                              <div class="modal-content">
                                  <div class="modal-header">
                                      <h5 class="modal-title">Reservation List</h5>
                                  </div>
                                  <div class="modal-body">
                                      <div :class="`loader${loaderClass}`" v-show="resEnrichloading"></div>
                                      <table aria-describedby="table" class="table table-sm">
                                          <thead>
                                            <tr class="table-primary">
                                                <th></th>
                                                <th>Reservation#</th>
                                                <th>Truck Type</th>
                                                <th>Location From</th>
                                                <th>Location To</th>
                                                <th>Unit#</th>
                                                <th>Status</th>
                                                <th>From Date</th>
                                                <th>To Date</th>
                                                <th>Customer</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                              <template v-if="enrichResArr.length > 0">
                                                  <tr :key="'res'+resKey" v-for="(res,resKey) in enrichResArr">
                                                      <td><input type="checkbox" value=""></td>
                                                      <td>{{ res.reference_no }}</td>
                                                      <td>{{ res.vehicle_type }}</td>
                                                      <td>{{ res.location_from_name }}</td>
                                                      <td>{{ res.location_to_name }}</td>
                                                      <td>{{ res.unit_no }}</td>
                                                      <td>{{ res.status }}</td>
                                                      <td>{{ res.pickup_time }}</td>
                                                      <td>{{ res.dropoff_time }}</td>
                                                      <td>{{ res.customer_name }}</td>
                                                  </tr>
                                              </template>
                                              <template v-else>
                                                  <tr><td colspan="9">No reservation found.</td></tr>
                                              </template>
                                          </tbody>
                                      </table>
                                      <template v-if="dataNotFound.length > 0">
                                          <span class="error">Following details not found in to the system, Please sync it from Enrich.</span>
                                          <table aria-describedby="table" class="table table-sm">
                                              <thead>
                                                <tr class="table-primary">
                                                    <th>Unit#</th>
                                                    <th>Message</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr :key="'notFound'+notKey" v-for="(notFound,notKey) in dataNotFound">
                                                    <td>{{ notFound.unit_no }}</td>
                                                    <td>{{ notFound.message }}</td>
                                                </tr>
                                              </tbody>
                                          </table>
                                      </template>
                                  </div>
                                  <div class="modal-footer">
                                      <button class="btn btn-primary" id="download_inv_btn">Map</button>
                                      <button type="button" class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                                  </div>
                              </div>
                          </div>
                      </div>
                </div>
          </template>
          <template v-else-if="cantAccess === false">
              <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <!-- <app-footer></app-footer> -->
      </template>
  </div>
</template>
<script>
import EventBus from ".././event-bus";
import Vue from "vue";
import { commonMixins } from "../../mixins/commonMixins";
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "listBooking",
  mixins: [commonMixins,dataTableMixins],

  props: {
      reservationVal: {
          type: Array,
          required: true,
          default:undefined
      },
      filterName: {
          type: String,
          required: false,
          default:undefined
      },
      listFlag: {
          type: String,
          required: false,
          default:undefined
      },
      customerId: {
          type: String,
          required: false,
          default:undefined
      }

  },
  data: () => ({
    hideButton: false,
    resEnrichloading:false,
    firstLoad: 0,
    userRole: "",
    permissions: [],
    enrichResArr:[],
    dataNotFound:[],
    userColumns:[],
    rental_reservation_value: true,
    rowSelection: [],
    selectedIds: [],
    isNotActiveOrPending: true,
    reason: "",
    comment: "",
    columns: [

      {
        label: "#Reference",
        field: "reference_no",
        width: '50px',
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "#Reference", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "#Unit",
        field: "unit_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "#Unit", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Customer Name",
        field: "company",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Customer Name", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
       {
           label: "Location",
           field: "location",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Location", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }

       },
       {
           label: "Physical Location",
           field: "physical_location",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Physical Location", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }

       },
      {
        label: "Start Date",
        field: "pickup_datetime",
        filterable: true,
        fpFieldType:"date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "End Date",
        field: "dropoff_datetime",
        fpFieldType:"date",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
           label: "Status",
           field: "reservation_status",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Status", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }

      },
      {
        label: "Created Date",
        field: "created_at",
        filterable: true,
        fpFieldType:"date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Total",
        field: "total",
        type: "number",
        filterable: true,
        fpFieldType:"integer",
        hidden:false,
      },      
      {
        label: "VIN",
        field: "vin_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        filterOptions: {
          enabled: false,
          placeholder: "VIN No.",
          filterValue: "",
          trigger: "enter"
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    cancel_booking_id: 0,
    cancelvalue: "",
    loading: false,
    cantAccess: true,
    flag: "",
    viewRes: false,
    exportRes: false,
    addRes: false,
    idArr:[],
    pageKey:"_cache_reservation_list_",
    fromUrl : "",
    batchProcess:0,
    batchNum:"",
    action:"",
  }),
  watch: {
    permissions: function(permission) {
      var self = this;
      permission.forEach(function(permissions) {
        if (permissions.name == "list_reservation") {
          self.cantAccess = true;
        }
        if (permissions.name == "view_reservation") {
          self.viewRes = true;
        }
        if (permissions.name == "export_reservation") {
          self.exportRes = true;
        }
        if (permissions.name == "add_reservation") {
          self.addRes = true;
        }
      });
      if (self.cantAccess == "") {
        self.cantAccess = false;
      }
    },
    '$route.path':function(val,oldval){
          var self = this;
          console.log(val);
          console.log(oldval);
          // this.mounted();

        setTimeout(function(){

          self.loadList();
        },100);
      },

      reservationVal:function(newVal,oldVal){
        var self = this;

        if (oldVal[1] != newVal[1]){

          self.loadList();
        }
      }

  },

  mounted: function() {
    var self = this;
    //check user loggged in or not
    var userObj = localStorage.getItem("user_obj");

    //if user logged in than remove login button and registration button
    if (userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        this.userRole = userJson.roles[0].name;
        this.loggedinUserId = userJson.id;
      }

      // console.log('filterName =-==', this.filterName);

      // EventBus.$emit("logged-in", false, userJson["contact"], this.userRole);
    }
    // EventBus.$emit("profile", false);
    // if (this.perPage) {
    //     this.currentPerPage = this.perPage;
    // }

    if (this.userRole == "customer") {
      this.$router.push("/");
    }
      if ( self.listFlag == "customerReservation" ) {

          for (let index = 0; index < this.columns.length; index++) {

              if(this.columns[index].field == 'company'){
                  this.$set(this.columns[index], 'hidden', true);
              }
          }
      }else{

        this.getPermissions();


      }
       // console.log("qqqq"+this.reservationVal[1]);
    if(this.reservationVal[1] == "ReservationListingReport"){

      this.hideButton = true;

    }


  },
  methods: {
      cancelAll: function (cancelAll) {
              this.$refs.reservationListTable.unselectAllInternal();
            },

      //Syncing enrich reservation
      syncReservation: function () {

          var self = this;

          //clear previous data
          self.enrichResArr = [];
          self.dataNotFound = [];

          //open modal to display reservation list
          $('#reservation_modal').modal('show');
          self.resEnrichloading = true;


          $.ajax({
              url: process.env.ROOT_API + "/sync_enrich_reservation",
              type: "post",
              crossDomain: true,
              dataType: "json",
              headers: this.ajxHeaders,
              success: function(data) {
                  self.resEnrichloading = false;
                  if (data.status == "success") {

                      self.enrichResArr = data.content.reservationArr;
                      self.dataNotFound = data.content.notFoundArr;

                  }
              },
              error: function(jqXHR, exception) {
                  // self.$router.push("/./listbookings");
                  self.generateStatusCodeMessage(jqXHR,true,'reservation-sync-enrich')
              }
          });

      },
    //
    selectAction: function(id, truck_id, from, resvId) {
      var self = this;


      if (from == "view") {
        localStorage.setItem("truck_id", truck_id);
          localStorage.setItem("reservationId", resvId);

          
          if (self.reservationVal[1] == "getpastreservation") {
            self.flag = "getpastreservation";
          }
        if(self.listFlag == 'customerReservation' ){
          self.fromUrl = btoa(window.location.pathname);
          self.$router.push({
            name: "ReservationContent",
            params: { id: id, flag: self.flag },
            query: {fromUrl : self.fromUrl}
          });
        }else {

          self.$router.push({
            name: "ReservationContent",
            params: { id: id, flag: self.flag },

          });
        }

        // self.$router.push("/viewbookings/" + id);
      }

      if (from == "cancel") {
        self.cancel_booking_id = id;

        this.$swal({
          title: "Are you sure?",
          text: "Reason for cancellation",
          type: "warning",
          input: "textarea",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Close",
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then(result => {
          if (result.value) {
            //getting comment value for reason of cancellation
            self.comment = JSON.stringify(result.value);

            $.ajax({
              url:
                process.env.API +
                "/" +
                process.env.VERSION +
                "/cancel_booking",
              type: "get",
              crossDomain: true,
              dataType: "json",
              headers: this.ajxHeaders,
              data: {
                id: self.cancel_booking_id,
                comment: self.comment,
                user_id: self.loggedinUserId
              },
              success: function(data) {
                //console.log(data.content[0]["id"]);
                if (data.status == "success") {
                  location.reload();
                  console.log(data.content);
                  self.loading = false;
                  // self.$router.push("/./listbookings");
                }
              },
              error: function(jqXHR, exception) {
                // self.$router.push("/./listbookings");
                  self.generateStatusCodeMessage(jqXHR,true,'reservation-cancle-booking')
              }
            });
          } else if (result.dismiss) {
            // self.$router.push("/./listbookings");
          }
        });
      }
      // }
    },
    makeReservationNew: function(){
        var page = this.$route.path.split('/');
        var type = '';
        console.log(page[2]);

        var string = "&from="+page[2]+"&url_type=current";
        this.$router.push({ name: 'MakeReservation', query: { data : btoa(string) }});

    },

    // // loadList is what brings back the rows from server
    loadList: function() {

      var self = this;
      var page = self.$route.path.split('/');
      var type = '';
      console.log(page[2]);
      if (page && page[2] == 'lease'){
          // self.title = 'Lease Reservation';
          type = 'lease';
      }else{
          // self.title = 'Rental Reservation';
          type = 'rental';
      }

      if (self.reservationVal[1] == "getcurrentreservation" || self.reservationVal[1] == "ReservationListingReport" ) {
        self.flag = "getcurrentreservation";
      }
      if (self.reservationVal[1] == "getpastreservation") {
        self.flag = "getpastreservation";
      }
      if (self.reservationVal[1] == "getcustreservation") {
        self.flag = "getcustreservation";
      }
      self.idArr={'customerId':self.customerId};

      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var filterAll = self.serverParams.columnFilters;
      if ( self.action == "export" ) {
          filterAll = self.removeOptionArr(self.serverParams.columnFilters);
      }
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/list_bookings",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: filterAll,
          sort: this.serverParams.sort,
          offset: offset,
          flag: self.flag,
          type: type,
          paramArr: self.idArr,
          action: self.action,
          id: self.selectedIds,
          selectedRows: self.selectedIds,
          reason: self.comment,
          reason_id: self.reason
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {
             if(self.action == 'export' || self.action == 'export_queue'){
              if ( data.code == "201" ) {
                  alert(data.message);
              } else {
                  if ( self.action == "export" ) {
                      self.excel = data.content.web;
                      var save = document.createElement("a");
                      save.href = self.excel;
                      save.download = data.content.web;
                      save.target = "_blank";

                      document.body.appendChild(save);
                      save.click();
                      document.body.removeChild(save);

                  } else {

                      self.batchProcess = 1;
                      self.batchNum = data.content;
                  }
              }
              self.action = "";
              // self.loadList();
            }else{
              if (data.content.row != undefined) {
                            self.rows = data.content.row;
                          }

              self.totalRecords = data.content.totalRecords;
            }

            // TO DO - No need to display counter...
            //if list page load for the unsync customer
            /*if (self.reservationVal == "unsyncbooking") {
              EventBus.$emit("unSyncCustomerCnt", data.content.customerCnt);
              EventBus.$emit("unSyncPaymentCnt", data.content.paymentCnt);
              EventBus.$emit("unSyncReservationCnt", data.content.totalRecords);
            }*/
            console.log("past == ", data.content.pastReservationCount);
            console.log("current == ", data.content.currentReservationCount);
            if(self.customerId != undefined || self.reservationVal[1] == "ReservationListingReport"){

            }else {
                EventBus.$emit("pastReservationCount", data.content.pastReservationCount);
                EventBus.$emit("currentReservationCount", data.content.currentReservationCount);
                EventBus.$emit("pendingReservationCount", data.content.pendingReservationCount);
                EventBus.$emit("avelableunitCount", data.content.avelableunitCount);

            }
            self.action = ""
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-list-booking')
        }
      });
    },
    viewInvoice: function(id, flag) {
      var self = this;
      $("#invoice_modal .modal-body").html("");
      $("#invoice_modal").modal("show");
      this.loading = true;

      $.ajax({
        url:
          process.env.ROOT_API + "/download_invoice",
        type: "POST",
        crossDomain: true,

        headers: this.ajxHeaders,
        data: {
          booking_id: id,
          flag: flag
        },
        success: function(data) {
          self.loading = false;
          $("#invoice_modal .modal-body").html(data);
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-download-invoice')
        }
      });
    },
    addTruck: function() {
      var self = this;

      localStorage.removeItem("booking_id");
      localStorage.removeItem("truck_id");
      localStorage.removeItem("truck_type");

      self.$router.push("/");
    },
    exportReservation: function() {
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      var page = self.$route.path.split('/');
      var type = '';
      console.log(page[2]);
      if (page && page[2] == 'lease'){
          // self.title = 'Lease Reservation';
          type = 'lease';
      }else{
          // self.title = 'Rental Reservation';
          type = '';
      }

      $.ajax({
        url:
          process.env.ROOT_API +
          "/list_bookings",
        type: "POST",
        crossDomain: true,
        dataType: "json",
        headers: this.ajxHeaders,

        data: { page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          flag: self.flag,
        for_export:'true' ,
        type:type},
        success: function(data) {
          self.loading = false;
          console.log(data);
          if ( data.code == 201) {
            alert(data.message);
          }else{
            self.excel = data.content.web;
            // var filename = data.content.filename;
            var save = document.createElement("a");
            save.href = self.excel;
            // save.setAttribute('download', 'Reservation');
            save.download = data.content.file;
            save.target = "_blank";
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
          }

          // $("#invoice_modal .modal-body").html(data);
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'reservation-export-reservation')
        }
      });
    },
    selectionChanged(param) {
      var self = this;
      self.rowSelection = param.selectedRows;
      self.serverParams.selectedAll = false;
      if(param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      return;

    },
    reservationDelete: function (param) {
      var self = this;

      var tempData = self.rowSelection
      console.log("tempData", tempData)

      for (var i = 0; i < tempData.length; i++) {
        self.selectedIds.push(tempData[i].resvId)

        if (tempData[i].reservation_status.toLowerCase() == "billed"
          || tempData[i].reservation_status.toLowerCase() == "closed"
          || tempData[i].reservation_status.toLowerCase() == "voided"
          || tempData[i].reservation_status.toLowerCase() == "standby"
          || tempData[i].reservation_status.toLowerCase() == "rented") {
          self.isNotActiveOrPending = false
        }
      }

      if (!self.isNotActiveOrPending) {
        alert('you can not deleted rented, void or billed reservation')
        self.isNotActiveOrPending = true;
        this.$refs.reservationListTable.unselectAllInternal();
        self.selectedIds = [];
        return;
      }

      var options = [];
      $.ajax({
        url: process.env.ROOT_API + "/get_reasons",
        type: "GET",
        crossDomain: true,
        headers: this.ajxHeaders,
        data: {module:'reservation'},
        dataType: "json",
        success: function (data) {
          options = data;
          self.$swal({
            title: "Are you sure?",
            text: "Reason Of Remove",
            type: "warning",
            html:'<input type="textarea" id="swal-input1" class="swal2-input">',
            input: "select",
            inputOptions:options,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Close",
            showCloseButton: true,
            showLoaderOnConfirm: true,
            preConfirm: function (value) {
              return new Promise(function (resolve, reject) {
                if(value == 0 && $("#swal-input1").val() == ''){
                  self.$swal.showValidationError(
                    'Please Enter Reason.'
                  )
                  value = false;
                }
                resolve(value)
              })
            }
          }).then(result => {
            if ($("#swal-input1").val() == '') {
              $("#swal-input1").val("No Reason");
            }
            if (result.value) {
              self.comment = $("#swal-input1").val();
              self.reason = result.value;

              self.action = 'delete';
              self.loadList();
              self.selectedIds = []

            } else if (result.dismiss) {
              console.log("no")
            }
          });
        },
        error: function (jqXHR, exception) {
          self.generateStatusCodeMessage(jqXHR, true, 'reservation-get-reason')
        }
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reservation/ReservationList.vue